import forme from '../images/png/lavorazione/forme.jpg';
import provola from '../images/png/lavorazione/provola.jpg';
import ricotta from '../images/png/lavorazione/ricotte.jpg';

function Body(){

    return (

        <div className="container text-center my-5">
            <div className="row">
                <div className="col-sm shadow-lg p-3 mb-5 bg-white rounded ">
                    <p class="lead">
                    L'azienda agricola Scrofani Giorgio si trova immersa nella rigogliosa campagna tra la Val di Noto, Palazzolo A. e Ragusa Ibla in c/da Cozzo Freddo-Modica (RG). 
                    La nostra piccola impresa a conduzione familiare nasce dalla tradizione trasmessa dai nostri nonni per la produzione e la successiva caseificazione del latte. 
                    </p>
                </div>

                <div className="col-sm shadow-lg p-3 mb-5 bg-white rounded bg-black">
                    <p class="lead">
                    I nostri animali vivono soprattutto di pascoli e foraggi di nostra produzione, questo per garantire il benessere animale e la qualità del prodotto finale.
                    </p>
                
                </div>
                <div className="col-sm shadow-lg p-3 mb-5 bg-white rounded">

                    <p class="lead">
                    Con il nostro latte produciamo la ricotta, le provole e il caciocavallo ragusano; le nostre specialità riguardano i prodotti a pasta filata come i cacetti con origano, pepe rosso e pepe nero. 
                    </p>
                
                </div>
            </div>

            <div className="row">
                <div class="col">
                    <img src={forme} class="card-img-top shadow-lg mb-5 bg-white " alt="..." />
                </div>
                <div className="col-5">
                    <img src={provola} class="card-img-top shadow-lg mb-5 bg-black " alt="..."/>
                </div>
                <div className="col">
                    <img src={ricotta} class="card-img-top shadow-lg mb-5 bg-white " alt="..."/>
                </div>
            </div>
        </div>

    );

}

export default Body;